(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nowet-welcome-offer"]) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.nwReady === 'true') return;
      root.dataset.nwReady = 'true';
      const panel = root.querySelector('.nw-welcome__panel');
      const launcher = root.querySelector('[data-nw-open]');
      const close = root.querySelector('[data-nw-close]');
      const form = root.querySelector('form');
      const signup = root.querySelector('[data-nw-signup]');
      const successPanel = root.querySelector('[data-nw-success-panel]');
      const key = 'nowet_welcome_50_v1';
      let state = {};
      try { state = JSON.parse(localStorage.getItem(key) || '{}'); } catch {}
      const succeeded = root.dataset.nwSuccess === 'true';
      const eligible = root.dataset.nwEligible === 'true';
      const hasError = root.dataset.nwError === 'true';
      const design = root.dataset.nwDesign === 'true';
      let returnFocus;
      let returnTimer;
      const save = (value) => {
        state = value;
        try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
      };
      const showSuccess = () => {
        signup.hidden = true;
        successPanel.hidden = false;
        const title = successPanel.querySelector('[data-nw-success-title]');
        title.id = panel.id + '-success-title';
        panel.setAttribute('aria-labelledby', title.id);
        panel.removeAttribute('aria-describedby');
      };
      const open = (manual = false) => {
        if (manual) returnFocus = document.activeElement;
        panel.hidden = false;
        launcher.hidden = true;
        if (manual) {
          const focusTarget = signup.hidden ? close : root.querySelector('input[type=email]');
          focusTarget?.focus({ preventScroll: true });
        }
      };
      const hide = () => {
        panel.hidden = true;
        launcher.hidden = false;
        if (!state.claimed) save({ dismissedAt: Date.now() });
        if (returnFocus && document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
        else if (panel.contains(document.activeElement)) launcher.focus({ preventScroll: true });
      };
      if (succeeded || eligible || state.claimed) showSuccess();
      if (succeeded) save({ claimed: true });
      launcher.addEventListener('click', () => open(true));
      close.addEventListener('click', hide);
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); hide(); }
      });
      form?.addEventListener('submit', (event) => {
        if (!form.checkValidity()) return;
        const button = form.querySelector('[data-nw-submit]');
        if (button.disabled) { event.preventDefault(); return; }
        button.disabled = true;
        returnTimer = setTimeout(() => { button.disabled = false; }, 15000);
      });
      window.addEventListener('pageshow', () => {
        const button = form?.querySelector('[data-nw-submit]');
        if (button) button.disabled = false;
      });
      root.querySelector('[data-nw-copy]')?.addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const code = root.querySelector('[data-nw-code]');
        try {
          await navigator.clipboard.writeText(code.textContent.trim());
          button.textContent = button.dataset.nwCopied;
        } catch {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(code);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      });
      if (design || succeeded || hasError) open(false);
      else {
        launcher.hidden = false;
        const suppressed = state.claimed || eligible || Date.now() - (state.dismissedAt || 0) < Number(root.dataset.nwDays) * 86400000;
        if (!suppressed) setTimeout(() => open(false), Number(root.dataset.nwDelay) || 2000);
      }
    };
    document.querySelectorAll('[data-nw-welcome]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => { event.target.querySelectorAll('[data-nw-welcome]').forEach(init); });
  })();

  } catch(e) { console.error(e); }
})();
})();
